import { API_ENDPOINTS } from "./endpoints";
import { requestJson, toArray } from "./httpClient";

export const fetchOffers = async ({ mine = false } = {}) => {
    const url = mine ? `${API_ENDPOINTS.offers.list}?mine=true` : API_ENDPOINTS.offers.list;
    const data = await requestJson(url, {
        method: "POST",
        body: {}
    });
    return toArray(data);
};
